//import { ColumnConfig } from '../models/column-config.model';

// ColumnConfig interface (if not already defined)

interface ColumnConfig {
group: 'main' | 'entry' | 'exit' | 'misc';
label: string;
key: string;
field: string;
/** timelineDirective: PSLShowWith/After/ExitWith/After — stored as VARCHAR directive, resolved at PPT export */
type?: 'text' | 'number' | 'checkbox' | 'timelineDirective';
width?: string;
}


// Define shared configs

// Column config map
export const mainColumns: ColumnConfig[] = [
{ group: 'main', label: 'Name',key: 'Name', field: 'PSLrawName', type: 'text', width: '12rem' },
{ group: 'main', label: 'type',key: 'Type', field: 'PSLtype', type: 'text', width: '6rem' },
{ group: 'main', label: 'Value',key: 'Value', field: 'PSLValue', type: 'text', width: '6rem' },
{ group: 'main', label: 'Source Type',key: 'SrcType', field: 'PSLSourceType', type: 'text', width: '6rem' }
];
export const entryColumns: ColumnConfig[] = [
{ group: 'entry', label: 'Show With',key: 'EntShowWith', field: 'PSLShowWith', type: 'timelineDirective' },
{ group: 'entry', label: 'Show after',key: 'EntShowAfter', field: 'PSLShowAfter', type: 'timelineDirective' },
{ group: 'entry', label: 'Delay (ms)',key: 'EntDelay', field: 'PSLShowDelay', type: 'number' }
];
export const exitColumns: ColumnConfig[] = [
{ group: 'exit', label: 'Exit with',key: 'ExitShowWith', field: 'PSLExitWith', type: 'timelineDirective' },
{ group: 'exit', label: 'Exit after',key: 'ExitShowAfter', field: 'PSLExitAfter', type: 'timelineDirective' },
{ group: 'exit', label: 'Delay (ms)', key: 'ExitDelay',field: 'PSLExitDelay', type: 'number' }
];
export const miscColumns: ColumnConfig[] = [
{ group: 'misc', label: 'Audio Options',key: 'AudioOptions', field: 'PSLAudioDirect' },
{ group: 'misc', label: 'Audio text', key: 'AudioText',field: 'PSLAudioValue' },
{ group: 'misc', label: 'Reading material', key: 'ReadingMaterial', field: 'PSLReadingMaterial' },
{ group: 'misc', label: 'Hyperlink',key: 'HyperLink', field: 'PSLHyperlink' }
];

